<template>
    <div class="embed-responsive embed-responsive-16by9 vimeo-video">
        <div class="video" :class="{ isPlaying: isPlaying }">
            <vueVimeoPlayer
                ref="player"
                :video-id="videoId"
                :options="options"
                @pause="onPause"
            ></vueVimeoPlayer>
            <span class="play-icon" @click="togglePlay"></span>
        </div>
    </div>
</template>

<script>
import { vueVimeoPlayer } from 'vue-vimeo-player'

export default {
    name: "VimeoVideo",
    props: {
        videoId: {
            type: String,
            required: true
        },
    },
    components: {vueVimeoPlayer},
    data: () => ({
        isPlaying: false,
        options: {
            byline: false,
            title: false,
            controls: true
        }
    }),
    mounted() {
        this.options.color = this.$vuetify.theme.themes.light.primary
    },
    methods: {
        onPause() {
            this.pause()
        },
        togglePlay() {
            if (this.isPlaying) {
                this.pause()
            } else {
                this.play()
            }
        },
        play() {
            this.isPlaying = true
            this.$refs.player.play()
        },
        pause() {
            this.isPlaying = false
            this.$refs.player.pause()
        },
    },
}
</script>

<style scoped>

</style>
